import { useReducer, useEffect, useState } from "react";
import { database, timestamp } from "../firebase/config";

let initialState = {
  document: null,
  isPending: false,
  error: null,
  success: null,
};

const firestoreReducer = (state, action) => {
  switch (action.type) {
    case "IS_PENDING":
      return {
        document: null,
        isPending: true,
        success: false,
        error: null,
      };
    case "ERROR":
      return {
        document: null,
        isPending: false,
        success: false,
        error: action.payload,
      };
    case "ADDED_DOCUMENT":
      return {
        document: action.payload,
        isPending: false,
        success: true,
        error: null,
      };
    case "DELETED_DOCUMENT":
      return {
        document: null,
        isPending: false,
        success: true,
        error: null,
      };
    case "UPDATED_DOCUMENT":
      return {
        document: action.payload,
        isPending: false,
        success: true,
        error: null,
      };
    case "RESET_STATE":
      return {
        document: null,
        isPending: false,
        success: null,
        error: null,
      };
    default:
      return state;
  }
};

export const useFirestore = (collection) => {
  const [response, dispatch] = useReducer(firestoreReducer, initialState);
  const [isCancelled, setIsCancelled] = useState(false);

  // creare riferimento alla collection per non dovrer richiamare tutto ma solo ref.add() (esempio di un metodo)
  const ref = database.collection(collection);

  // eseguire il dispatch solo se isCancelled è false
  const dispatchIfNotCancelled = (action) => {
    if (!isCancelled) {
      dispatch(action);
    }
  };

  // aggiungere documento
  const addDocument = async (doc) => {
    dispatch({ type: "IS_PENDING" });
    try {
      const createdAt = timestamp.fromDate(new Date());
      const addedDocument = await ref.add({ ...doc, createdAt });
      console.log("Documento aggiunto:", addedDocument);
      console.log("ID documento:", addedDocument.id);
      console.log("Path documento:", addedDocument.path);

      // Creiamo un oggetto con l'id del documento per il reindirizzamento
      const documentWithId = {
        id: addedDocument.id,
        path: addedDocument.path,
      };
      console.log("Oggetto documentWithId creato:", documentWithId);

      dispatchIfNotCancelled({
        type: "ADDED_DOCUMENT",
        payload: documentWithId,
      });
      return documentWithId;
    } catch (err) {
      console.error("Errore durante l'aggiunta del documento:", err);
      dispatchIfNotCancelled({ type: "ERROR", payload: err.message });
      return null;
    }
  };

  // eliminare documento
  const deleteDocument = async (id) => {
    dispatch({ type: "IS_PENDING" });
    try {
      await ref.doc(id).delete();
      dispatchIfNotCancelled({
        type: "DELETED_DOCUMENT",
      });
    } catch (err) {
      dispatchIfNotCancelled({
        type: "ERROR",
        payload: "impossibile eliminare",
      });
    }
  };

  // modificare un documento
  const updateDocument = async (id, updates) => {
    dispatch({ type: "IS_PENDING" });
    try {
      const updatedDocument = await ref.doc(id).update(updates);
      dispatchIfNotCancelled({
        type: "UPDATED_DOCUMENT",
        payload: updatedDocument,
      });
      return updatedDocument;
    } catch (err) {
      dispatchIfNotCancelled({
        type: "ERROR",
        payload: "impossibile aggiornare",
      });
      return null;
    }
  };

  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  const resetResponse = () => {
    dispatch({ type: "RESET_STATE" });
  };

  return {
    addDocument,
    deleteDocument,
    updateDocument,
    resetResponse,
    response,
  };
};
